import React from 'react';
import { Layout } from '../components/Layout';
import { SEO, pageSEO } from '../components/SEO';
import { Card, CardContent } from '../components/ui/Card';
import { Calendar, User, ArrowRight, Sparkles, Facebook, Linkedin } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Link } from 'react-router-dom';
export function BlogPage() {
  const posts = [{
    id: 4,
    title: 'Retour sur le 1er Atelier National ADCC : 41 participants, 8 modules, une ambition',
    excerpt: "Du 12 au 14 mars 2026, l'ADCC a organisé son tout premier atelier national de renforcement des capacités dédié aux métiers de l'entretien et de la maintenance, réunissant 41 participants. Un événement fondateur avec le soutien de la Mairie de Cotonou, Care International et bien d'autres partenaires.",
    date: '16 Mar 2026',
    author: 'Équipe ADCC',
    category: 'FORMATION',
    image: 'https://cdn.magicpatterns.com/uploads/opPxzmWiMSRTC4qTrQ2YSj/WhatsApp_Image_2026-03-16_at_14.07.52_(3).jpg',
    featured: true
  }, {
    id: 1,
    title: "Forum Fondateur : L'ADCC à l'écoute des personnels de maison",
    excerpt: 'Retour sur notre tout premier événement qui a réuni une dizaine de personnels de maison de différents domaines. Une rencontre fondatrice qui a permis de cartographier les besoins réels et de poser les bases de notre action.',
    date: '10 Jan 2026',
    author: 'Équipe ADCC',
    category: 'ARTICLE',
    image: 'https://cdn.magicpatterns.com/uploads/exRoSvgKroC4rrK6KpbESt/WhatsApp_Image_2026-01-29_at_17.21.09.jpg',
    featured: false
  }, {
    id: 3,
    title: "L'importance de la certification dans les métiers de services",
    excerpt: "Pourquoi la reconnaissance officielle des compétences est cruciale pour l'autonomisation des travailleurs de maison et de l'hôtellerie au Bénin.",
    date: '10 Fév 2026',
    author: 'Marie D.',
    category: 'Expertise',
    image: 'https://cdn.magicpatterns.com/uploads/jfY9WFQQPLNmCKBmbcpuEW/Femmes_Menage_Emploi_3.png',
    featured: false
  }, {
    id: 2,
    title: 'Témoignage : Le parcours de Merveille',
    excerpt: "Découvrez comment l'accompagnement de l'ADCC a permis à Merveille de sécuriser un emploi digne dans l'hôtellerie après des années de précarité.",
    date: '25 Jan 2026',
    author: 'Paul A.',
    category: 'Impact',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?auto=format&fit=crop&q=80&w=800',
    featured: false
  }];
  const featuredPost = posts.find(p => p.featured);
  // Only taking the first regular post to match the screenshot layout exactly
  const regularPost = posts.find(p => p.id === 1);
  return <Layout data-id="element-738">
      <SEO {...pageSEO.blog} data-id="element-739" />

      {/* Header */}
      <div className="bg-[#2C3E50] text-white py-16 md:py-20" data-id="element-740">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-741">
          <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-742">
            Actualités ADCC
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-743">
            Suivez nos avancées, découvrez nos événements et restez informés de
            notre action pour l'insertion professionnelle digne.
          </p>
        </div>
      </div>

      <div className="py-16 bg-gray-50/50" data-id="element-744">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 space-y-20" data-id="element-745">
          {/* Featured Post Section */}
          {featuredPost && <section data-id="element-746">
              <div className="mb-6" data-id="element-747">
                <span className="inline-flex items-center gap-2 text-[#1E88E5] font-medium bg-blue-50 px-4 py-2 rounded-full text-sm" data-id="element-748">
                  <Sparkles className="w-4 h-4" data-id="element-749" />
                  Articles à la une
                </span>
              </div>

              <Card className="overflow-hidden border-none shadow-md bg-white hover:shadow-lg transition-shadow" data-id="element-750">
                <div className="flex flex-col md:flex-row" data-id="element-751">
                  <div className="relative md:w-5/12 h-64 md:h-auto overflow-hidden" data-id="element-752">
                    <img src={featuredPost.image} alt={featuredPost.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-753" />
                    <div className="absolute top-4 left-4" data-id="element-754">
                      <span className="bg-white text-[#1E88E5] px-3 py-1 rounded-full text-xs font-bold tracking-wide shadow-sm" data-id="element-755">
                        {featuredPost.category}
                      </span>
                    </div>
                  </div>
                  <CardContent className="p-8 md:w-7/12 flex flex-col justify-center" data-id="element-756">
                    <div className="flex items-center gap-4 text-xs text-gray-500 mb-4" data-id="element-757">
                      <span className="flex items-center gap-1.5" data-id="element-758">
                        <Calendar className="w-3.5 h-3.5" data-id="element-759" />
                        {featuredPost.date}
                      </span>
                      <span className="flex items-center gap-1.5" data-id="element-760">
                        <User className="w-3.5 h-3.5" data-id="element-761" />
                        {featuredPost.author}
                      </span>
                    </div>
                    <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-4 leading-snug" data-id="element-762">
                      {featuredPost.title}
                    </h2>
                    <p className="text-gray-600 text-sm mb-6 leading-relaxed" data-id="element-763">
                      {featuredPost.excerpt}
                    </p>
                    <div data-id="element-764">
                      <Link to={`/blog/article/${featuredPost.id}`} data-id="element-765">
                        <Button className="bg-[#1E88E5] hover:bg-[#1976D2] text-white gap-2 text-sm px-6" data-id="element-766">
                          Lire la suite
                          <ArrowRight className="w-4 h-4" data-id="element-767" />
                        </Button>
                      </Link>
                    </div>
                  </CardContent>
                </div>
              </Card>
            </section>}

          {/* Regular Posts Section */}
          {regularPost && <section data-id="element-768">
              <div className="mb-8" data-id="element-769">
                <h2 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-770">
                  Nos articles
                </h2>
                <p className="text-gray-500 text-sm" data-id="element-771">
                  Retour sur nos actions et réflexions
                </p>
              </div>

              <Card className="overflow-hidden border-none shadow-md bg-white hover:shadow-lg transition-shadow" data-id="element-772">
                <div className="flex flex-col md:flex-row" data-id="element-773">
                  <div className="relative md:w-5/12 h-64 md:h-auto overflow-hidden" data-id="element-774">
                    <img src={regularPost.image} alt={regularPost.title} className="absolute inset-0 w-full h-full object-cover" data-id="element-775" />
                    <div className="absolute top-4 left-4" data-id="element-776">
                      <span className="bg-white text-gray-700 px-3 py-1 rounded-full text-xs font-bold tracking-wide shadow-sm" data-id="element-777">
                        {regularPost.category}
                      </span>
                    </div>
                  </div>
                  <CardContent className="p-8 md:w-7/12 flex flex-col justify-center" data-id="element-778">
                    <div className="flex items-center gap-4 text-xs text-gray-500 mb-4" data-id="element-779">
                      <span className="flex items-center gap-1.5" data-id="element-780">
                        <Calendar className="w-3.5 h-3.5" data-id="element-781" />
                        {regularPost.date}
                      </span>
                      <span className="flex items-center gap-1.5" data-id="element-782">
                        <User className="w-3.5 h-3.5" data-id="element-783" />
                        {regularPost.author}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-900 mb-4 leading-snug" data-id="element-784">
                      {regularPost.title}
                    </h3>
                    <p className="text-gray-600 text-sm mb-6 leading-relaxed" data-id="element-785">
                      {regularPost.excerpt}
                    </p>
                    <div data-id="element-786">
                      <Link to={`/blog/article/${regularPost.id}`} data-id="element-787">
                        <Button className="bg-[#1E88E5] hover:bg-[#1976D2] text-white gap-2 text-sm px-6" data-id="element-788">
                          Lire la suite
                          <ArrowRight className="w-4 h-4" data-id="element-789" />
                        </Button>
                      </Link>
                    </div>
                  </CardContent>
                </div>
              </Card>
            </section>}

          {/* Social Media Section */}
          <section className="pt-8 border-t border-gray-200" data-id="element-790">
            <div className="text-center mb-8" data-id="element-791">
              <h2 className="text-2xl font-bold text-gray-900 mb-1" data-id="element-792">
                Sur nos réseaux
              </h2>
              <p className="text-gray-500 text-sm" data-id="element-793">
                Retrouvez-nous sur Facebook
              </p>
            </div>

            <div className="max-w-lg mx-auto flex justify-center" data-id="element-794">
              <iframe src="https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3Dpfbid02YsMRNYw52yNkxPBnEvdZFQ6EyzApzZEnFLuWzxz4dE4nqxzvM8fyzADkjmdxc25gl%26id%3D100075465236040&show_text=true&width=500" width="500" height="792" style={{
              border: 'none',
              overflow: 'hidden'
            }} scrolling="no" frameBorder="0" allowFullScreen={true} allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" title="Publication Facebook ADCC" data-id="element-795" />
            </div>
          </section>

          {/* CTA Banner */}
          <section data-id="element-796">
            <div className="bg-gradient-to-r from-[#1E88E5] to-[#1565C0] rounded-2xl p-8 md:p-12 text-center text-white shadow-lg" data-id="element-797">
              <h2 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-798">
                Restez informés de nos actualités
              </h2>
              <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-799">
                Suivez-nous sur les réseaux sociaux pour ne rien manquer de nos
                événements et de notre action.
              </p>
              <div className="flex flex-col sm:flex-row justify-center gap-4" data-id="element-800">
                <a href="https://www.facebook.com/profile.php?id=61587454706476" target="_blank" rel="noopener noreferrer" data-id="element-801">
                  <Button variant="ghost" className="bg-white text-[#1E88E5] hover:bg-gray-100 hover:text-[#1E88E5] w-full sm:w-auto gap-2 border border-white" data-id="element-802">
                    <Facebook className="w-4 h-4" data-id="element-803" />
                    Facebook
                  </Button>
                </a>
                <a href="https://www.linkedin.com/company/association-dignit%C3%A9-comp%C3%A9tence-cr%C3%A9ation-adcc" target="_blank" rel="noopener noreferrer" data-id="element-804">
                  <Button variant="ghost" className="bg-transparent text-white hover:bg-white/10 hover:text-white w-full sm:w-auto gap-2 border border-white" data-id="element-805">
                    <Linkedin className="w-4 h-4" data-id="element-806" />
                    LinkedIn
                  </Button>
                </a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </Layout>;
}